"use strict";

if (document.querySelector('.tabs-container')) {
  var menuItens = document.querySelectorAll('.tab-item');

  for (var i = 0; i < menuItens.length; i++) {
    menuItens[i].addEventListener('click', function () {
      if (!this.classList.contains('active')) {
        var id = this.dataset.id;
        var parent = this.closest('.tabs-container');
        var menuList = parent.querySelectorAll('.tab-item');
        var tabList = parent.querySelectorAll('.tab-block-item');

        for (var j = 0; j < menuList.length; j++) {
          menuList[j].classList.remove('active');
        }

        this.classList.add('active');

        for (var k = 0; k < tabList.length; k++) {
          tabList[k].classList.remove('active');
        }

        parent.querySelector('.tab-block-item[data-id="' + id + '"]').classList.add('active');
      }
    });
  }
}